import React from "react"
import { useTranslation } from "react-i18next"
import HeaderNavItem from "./HeaderNavItem"
import LanguageSwitcher from "../LanguageSwitcher"
import { analyticsAction } from "/src/utils/analytics"

function DesktopMenu({ signInUrl, signUpUrl }) {
  const { t } = useTranslation()

  return (
    <nav className="hidden fMd:flex fMd:flex-grow">
      {/* Desktop menu links */}
      <ul className="flex flex-grow justify-end items-center">
        <HeaderNavItem />
      </ul>

      {/* Desktop sign in links */}
      <ul className="flex flex-grow justify-end items-center">
        <li>
          <LanguageSwitcher />
        </li>
        <li>
          <a
            href={signInUrl}
            className="font-medium text-gray-300 hover:text-gray-200 px-4 py-3 flex items-center capitalize transition duration-150 ease-in-out"
            onClick={async () => await analyticsAction("landing_sign_in_click")}
          >
            {t("header.signIn")}
          </a>
        </li>

        <li>
          <a
            href={signUpUrl}
            className="btn-sm text-gray-800 bg-fOrange-900 hover:bg-fOrange-800 ml-3"
            onClick={async () => await analyticsAction("landing_sign_up_click")}
          >
            {t("header.tryForFree")}
          </a>
        </li>
      </ul>
    </nav>
  )
}

export default DesktopMenu
